<template>
    <div class="py-0 mt-4 mb-8">
        <v-container class="mx-0 my-0" style="padding:0 !important; max-width: 100% !important">
            <v-card class="mt-1 pt-1 pb-10 px-0 size" style="margin-bottom: 35px !important">
                
                <span v-for="data in this.filteredArray" :key="data.id">
                    <v-col cols="6" class="px-0 py-0" style="display:inline-block !important">
                        <v-card class="mx-2 mt-4 px-3 py-2" :to="data.link" style="font-size:13px;" cols="6">
                            <div class="decoration_bussy" v-if="data.status == 'bussy'"></div>
                            <div class="decoration_free" v-if="data.status == 'free'"></div>
                            <div class="decoration_process" v-if="data.status == 'process'"></div>
                            <div class="decoration_unprocessable" v-if="data.status == 'unprocessable'"></div>

                            <v-col class="px-2 mx-0" cols="12" md="12" align="start">
                                <v-row>
                                    <v-col v-if="data.status == 'free'" class="py-0 px-0 text-uppercase"
                                        style="color:rgb(186, 214, 0); font-weight: bold !important;" md="12"><span
                                            class="pr-1 secondary--text"></span> {{ data.name }}</v-col>
                                    <v-col v-if="data.status == 'bussy'" class="py-0 px-0 text-uppercase"
                                        style="color:rgb(252, 188, 16); font-weight: bold !important;" md="12"><span
                                            class="pr-1 secondary--text"></span>{{ data.name }} ({{ data.cliente
                                        }})</v-col>
                                    <v-col v-if="data.status == 'process'" class="py-0 px-0 text-uppercase"
                                        style="color: var(--v-error-base); font-weight: bold !important;" md="12"><span
                                            class="pr-1 secondary--text"></span>{{ data.name }} ({{ data.cliente
                                        }})</v-col>
                                    <v-col v-if="data.status == 'unprocessable'" class="py-0 px-0 text-uppercase"
                                        style="color: var(--v-accent-base); font-weight: bold !important;" md="12"><span
                                            class="pr-1 secondary--text"></span>{{ data.name }} ({{ data.cliente
                                        }})</v-col>
                                </v-row>
                                <v-row v-if="data.status == 'bussy'">
                                    <v-col cols="6" class="px-4 mx-0">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.appointment') }}: </span> {{ data.id }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.container') }}: </span> {{ data.bol }}
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">
                                                {{ $t('operation.schedule') }}: </span>
                                            {{ data.fecha_registro }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.operation') }}: </span><span>{{ data.maniobras
                                                }}</span>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row v-if="data.status == 'free'">
                                    <v-col cols="6" class="px-4 mx-0">
                                        <v-row>
                                            <span style="color:rgb(186, 214, 0) !important;"
                                                class="pr-1 secondary--text text-uppercase font-weight-bold">{{
                                                $t('on_premises_mobile.free') }}</span>
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold"><br></span>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold"><br></span>
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold"><br></span>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row v-if="data.status == 'process'">
                                    <v-col cols="6" class="px-4 mx-0">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.appointment') }}: </span> {{ data.id }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.container') }}: </span> {{ data.bol }}
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">
                                                {{ $t('operation.schedule') }}: </span>
                                            {{ data.fecha_registro }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.operation') }}: </span><span>{{ data.maniobras
                                                }}</span>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <v-row v-if="data.status == 'unprocessable'">
                                    <v-col cols="6" class="px-4 mx-0">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.appointment') }}: </span> {{ data.id }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.container') }}: </span> {{ data.bol }}
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">
                                                {{ $t('operation.schedule') }}: </span>
                                            {{ data.fecha_registro }}
                                        </v-row>
                                        <v-row>
                                            <span class="pr-1 blue_accent--text font-weight-bold">{{
                                                $t('operation.operation') }}: </span><span>{{ data.maniobras
                                                }}</span>
                                        </v-row>
                                    </v-col>
                                </v-row>

                            </v-col>
                        </v-card>
                    </v-col>
                </span>
            </v-card>
            <bottom-bar ref="bottombar" :from="from" :m_type="m_type"></bottom-bar>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center;">{{
            snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { appointmentOperationIndexUseCase } from '../../application/use_cases/appointment_operation_index_use_case';
import { indexGatesUseCase } from '../../../gates/application/use_cases/index_gates_use_case';
import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository';
import { HttpGateRepository } from '../../../gates/infrastructure/repositories/gate_repository';

export default {
    components: {},
    data() {
        return {
            from: this.$route.params.from,
            m_type: this.$route.params.m_type,
            snackbar: {
                visible: false,
                color: 'primary',
                timeout: 2000,
                text: ''
            },
            filteredArray: [],
            portals: [],
            props: {
                items: [],
                portals: [],
                search: '',
            },
        }
    },
    mounted() {
        localStorage.setItem('bottom', 2);
        this.$store.state.module = "headers.on_premises_operation";
        this.$store.state.bottom = 2;
        this.index();
    },
    methods: {
        handler(i, id) {
            if (i == 0) this.edit(id);
        },
        async index() {
            try{
                this.props.items = await appointmentOperationIndexUseCase('En rampa', this.from, this.m_type, HttpAppointmentRepository);
                const portals = await indexGatesUseCase(HttpGateRepository);

                portals.forEach(x => {
                    const appointment = this.props.items.find(item => {
                        if (item.gate_id != null && item.gate_id != undefined) {
                            if (item.gate_id == x.id) return item;
                        }
                    });

                    if (appointment != null && appointment != undefined) {
                        if(this.from == "national" && this.m_type == "income"){
                            if(appointment.is_national == true && appointment.operation.id == 5) this.drawProcessableAppointment(x, appointment);
                            else this.drawUnprocessableAppointment(x, appointment);
                        }
                        else if(this.from == "national" && this.m_type == "outcome"){
                            if(appointment.is_national == true && appointment.operation.id == 6) this.drawProcessableAppointment(x, appointment);
                            else this.drawUnprocessableAppointment(x, appointment);
                        }
                        else if(this.from == "international" && this.m_type == "income"){
                            if(appointment.is_national == false && appointment.operation.id % 2 != 0) this.drawProcessableAppointment(x, appointment);
                            else this.drawUnprocessableAppointment(x, appointment);
                        }
                        else if(this.from == "international" && this.m_type == "outcome"){
                            if(appointment.is_national == false && appointment.operation.id % 2 == 0) this.drawProcessableAppointment(x, appointment);
                            else this.drawUnprocessableAppointment(x, appointment);
                        }
                    }
                    else {
                        x.id = x.id + ' ';
                        x['status'] = 'free';
                        this.props.portals.push(x);
                    }
                });

                this.filteredArray = this.props.portals;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }  
        },
        drawProcessableAppointment(x, appointment) {
            x.cita = this.$t("on_premises_mobile.appointment") + ': ' + appointment.id + ', ' + appointment.operation.description + ' ' + this.$t("on_premises_mobile.to") + ' ' + appointment.client.name + ', ' + this.$t("on_premises_mobile.container") + ': ' + appointment.container_number;
            x.cliente = appointment.client.name;
            x.id = appointment.id;
            x.bol = appointment.container_number;
            x.fecha_registro = appointment.arrival_date.toString().substring(0, 10);
            x.maniobras = appointment.operation.description;
            x.appointmentStatus = appointment.status;

            if (appointment.status == "En rampa") {
                x['status'] = 'bussy';
                x['link'] = '/operation/start-processing/' + x.id + '/' + this.from + '/' + this.m_type;
                this.props.portals.push(x);
            }
            else {
                x['status'] = 'process';
                x['link'] = '';
                this.props.portals.push(x);
            }
        },
        drawUnprocessableAppointment(x, appointment) {
            x.cita = this.$t("on_premises_mobile.appointment") + ': ' + appointment.id + ', ' + appointment.operation.description + ' ' + this.$t("on_premises_mobile.to") + ' ' + appointment.client.name + ', ' + this.$t("on_premises_mobile.container") + ': ' + appointment.container_number;
            x.cliente = appointment.client.name;
            x.id = appointment.id;
            x.bol = appointment.container_number;
            x.fecha_registro = appointment.arrival_date.toString().substring(0, 10);
            x.maniobras = appointment.operation.description;
            x.appointmentStatus = appointment.status;
            x['status'] = 'unprocessable';
            x['link'] = '';
            this.props.portals.push(x);
        }
    },
    watch: {}
}
</script>

<style lang="css">
</style>